import React, { PropsWithChildren, ReactNode } from 'react';
import { Theme, useCurrentTheme } from '../hooks';

export const ThemeContext = React.createContext<Theme | null>(null);

interface ThemeProviderProps {
  theme?: Theme;
  rootElement?: HTMLElement;
}

export const ThemeProvider: React.FC<PropsWithChildren<ThemeProviderProps>> = ({
  theme = 'light',
  rootElement = document.documentElement,
  children,
}) => {
  rootElement.setAttribute('data-theme', theme);
  return <ThemeContext.Provider value={theme}>{children}</ThemeContext.Provider>;
};

export const UserPreferenceThemeProvider = ({ children }: { children: ReactNode }) => {
  const theme = useCurrentTheme();

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};
